import {Props as ReportsTableColumnProps} from 'modules/reports/components/Table/Column/ReportsTableColumn'
import {ReportsTableContextProps} from 'modules/reports/components/Table/ReportsTable.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import {TableCellProps} from 'react-virtualized'
import {TableCell} from '@material-ui/core'

type Props = TableCellProps & ReportsTableContextProps & {className?: string}

function ReportsTableCell(props: Props) {
  const {rowData, cellData, dataKey, rowIndex, className, tableOnClick} = props
  const column = props.columnData as ReportsTableColumnProps
  const p = usePrefix(`${props.tablePrefix}-${rowIndex}-${dataKey}`)

  const loading = Object.keys(rowData).length === 0
  if (loading) return null

  function getValue() {
    const {name, children} = column
    if (children) return children(rowData)

    if (!name) throw new Error('Attempting to use unamed column without a children function')
    return cellData || null
  }

  function handleClick() {
    if (!column.noLabel) tableOnClick(rowData)
  }

  const style: React.CSSProperties = {}
  if (!column.noLabel) style.cursor = 'pointer'

  return (
    <TableCell
      component="div"
      className={className}
      data-testid={p()}
      onClick={handleClick}
      style={style}
    >
      {getValue()}
    </TableCell>
  )
}

export default ReportsTableCell
